module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.bc405e8.ttf";